<template>
  <div class="scraper-logs-page min-w-0">
    <Head :title="__('Collector log')" />
    <ScraperLogApp :tail-url="tailUrl" :poll-ms="pollMs" />
  </div>
</template>

<script setup>
import ScraperLogApp from '../components/ScraperLogApp.vue'

defineProps({
  tailUrl: {
    type: String,
    required: true,
  },
  pollMs: {
    type: Number,
    default: 3000,
  },
})
</script>
